/** Rewrite backend session HTTP paths to Next.js BFF routes (WebSocket URLs stay unchanged). */
export function rewriteSessionApiToBff(backendPath: string, sessionId: string): string {
  return backendPath.replace(
    `/api/v1/sessions/${sessionId}/`,
    `/api/compiler/sessions/${encodeURIComponent(sessionId)}/`,
  )
}

/** BFF history URL. The snapshot API needs the project id as a query parameter. */
export function crdtHistoryBffUrl(
  backendPath: string | undefined,
  sessionId: string,
  projectId: string | undefined,
): string | undefined {
  if (!backendPath) return undefined
  const bff = rewriteSessionApiToBff(backendPath, sessionId)
  if (!projectId) return bff
  const url = new URL(bff, "http://localhost")
  url.searchParams.set("project_id", projectId)
  return `${url.pathname}${url.search}`
}
